import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material';
import { BOMaterialModule } from '../material-module';
import { AuthorTypeaheadComponent } from './components/authorTypeahead/author.typeahead.component';
import { TagSelectorComponent } from './components/tagSelector/tagSelector.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ButtonToggleGroupComponent} from './components/buttonToggleGroup/buttonToggleGroup.component';


@NgModule({
  imports:[
    MatAutocompleteModule,
    BOMaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot()
  ],
  declarations: [
    AuthorTypeaheadComponent,
    TagSelectorComponent,
    ButtonToggleGroupComponent
  ],
  exports: [
    AuthorTypeaheadComponent,
    ButtonToggleGroupComponent,
    TagSelectorComponent
  ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts